import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListConceptos from './Components/ListConceptos';
import ConceptoNew from './Components/ConceptoNew';

export default class AdmConceptos extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListConceptos/>}/>
                    <Route path="Nuevo" element={<ConceptoNew/>}/>
                </Routes>
            </div>
        );
    }
}